import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import BlockedTasksList from "./BlockedTasksList";
import $ from 'jquery'
import messageResource from '../../messageResource'

export default class DeleteTasksConfirmationDialog extends DeleteConfirmationDialog {
    constructor($container, cancelHandler, deleteHandler) {
        super($container, cancelHandler, deleteHandler);
    }

    show() {
        super.show()
        this.savingState = false
        this.$el.removeClass("savingState");
    }

    createBlockedEntitiesList()
    {
        const otherBlockedTaskCount = this.state.entitiesBlockedCount - this.state.entitiesBlocked.length
        return new BlockedTasksList($("body"), this.state.entitiesBlocked, otherBlockedTaskCount).init();
    }

    titleText()
    {
        if (this.allBlocked())
        {
            return messageResource.getMessage("delete.confirm.dialog.task.all_blocked.title",
                                              [messageResource.getMessage(this.state.entitiesToDeleteCount > 1 ? "common.tasks" : "common.task")]);
        }
        else
        {
            if (this.state.entitiesToDeleteCount > 1)
                return messageResource.getMessage("delete.confirm.dialog.about_to_delete.more_one", [this.state.entitiesToDeleteCount]);
            else
                return messageResource.getMessage("delete.confirm.dialog.about_to_delete.one_task");
        }
    }

    firstOrangeSentence()
    {
        if (this.allBlocked())
        {
            return this.blockedWarningOtherText();
        }
        else
        {
            if (this.hasTimeTrack())
            {
                return messageResource.getMessage("delete.confirm.dialog.about_to_delete.warning");
            }
            else
            {
                return messageResource.getMessage("delete.confirm.dialog.about_to_delete", [this._getTaskOrTasksText()]);
            }
        }
    }

    secondOrangeSentence()
    {
        if (this.allBlocked())
        {
            return "";
        }
        else
        {
            if (this.hasTimeTrack())
                return messageResource.getMessage("delete.confirm.dialog.about_to_delete.confirm");
            else
                return messageResource.getMessage("delete.confirm.dialog.about_to_delete.warning");
        }
    }

    removeEntitiesPointText()
    {
        return messageResource.getMessage("delete.confirm.dialog.about_remove_task", [this._getTaskOrTasksText()]);
    }

    removeTimeTrackPointText()
    {
        return messageResource.getMessage("delete.confirm.dialog.about_remove_time_track", [this._getTaskOrTasksText()]);
    }

    blockedWarningLinkText()
    {
        return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_link_text");
    }

    blockedWarningOtherText()
    {
        if (this.state.entitiesBlockedDueToLockedTimeCount > 0 && this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount === 0)
        {
            if (this.state.entitiesBlockedDueToLockedTimeCount === 1)
                return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.one_locked");
            return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.locked");
        }
        else if (this.state.entitiesBlockedDueToLockedTimeCount === 0 && this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount > 0)
        {
            if (this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount === 1)
                return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.cannot_modify_one_task");
            return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.cannot_modify");
        }
        else if (this.state.entitiesBlockedDueToLockedTimeCount > 0 && this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount > 0)
        {
            if (this.state.entitiesBlockedCount === 1)
                return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.locked_and_cannot_modify_one_task");
            return messageResource.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.locked_and_cannot_modify");
        }
        return ""
    }

    deleteButtonText()
    {
        if (this.state.entitiesWithOtherUsersTimeTrackCount > 0 || this.state.entitiesWithManagerTimeTrackCount > 0)
        {
            return messageResource.getMessage("delete.confirm.dialog.delete_task_with_entries");
        }
        else
        {
            return messageResource.getMessage("delete.confirm.dialog.delete_task_permanently");
        }
    }

    _getTaskOrTasksText()
    {
        return messageResource.getMessage(this.state.entitiesToDeleteCount - this.state.entitiesBlockedCount === 1 ?
                                          "delete.confirm.dialog.this_task" :
                                          "delete.confirm.dialog.these_tasks");
    }
}



// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/DeleteTasksConfirmationDialog.js